import { apiRequest, ApiRequestFailure, HTTP_GET } from 'helpers/http';
import { Either } from 'fp-ts/lib/Either';

const magentoRequest = apiRequest(process.env.GATSBY_MAGENTO_API_BASE_URL);
export type PriceTier = {
    'quantity': number;
    'label': string;
    'option_id': number | null;
    'option_value': string | null;
}
export const getTieredPricing = (sku: string): Promise<Either<ApiRequestFailure, PriceTier[]>> => magentoRequest('au', 'products', sku, 'price-tiers')(HTTP_GET)()<PriceTier[]>();
